import { STOCK_IMAGE_MAX_MATCH_RANK } from '~/constants/vdp/whyBuyMedia';
import optimizeImage from '~/utilities/optimizeImage';
import type { SelectedWhyBuyMedia } from './selectWhyBuyMedia';

type WhyBuyMediaProps = {
  imageUrl?: string;
  isStockImage: boolean;
  videoUrl?: string;
};

type Options = {
  height: number;
};

export default function getWhyBuyMediaProps(
  media: SelectedWhyBuyMedia | undefined,
  { height }: Options
): WhyBuyMediaProps {
  if (!media) {
    return { isStockImage: false };
  }

  const isStockImage = media.matchRank <= STOCK_IMAGE_MAX_MATCH_RANK;

  if (media.mimeType.startsWith('video/')) {
    return { isStockImage, videoUrl: media.url };
  }

  const imageUrl = optimizeImage(media.url, {
    format: 'auto',
    height,
    optimize: 'high',
    quality: 90
  });

  return imageUrl ? { imageUrl, isStockImage } : { isStockImage: false };
}
